import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { ListDivider, ListItemGraphic} from 'rmwc/List';
import StarRatings from 'react-star-ratings';
import ReactTooltip from 'react-tooltip'

class UserInternalResouceComponent extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            rating: '0.0',
            bookmarkStatus: '',
            archiveStatus: false,
            existingRating: '',
            readStatus: '',
            elementView: '',
    		data:{
    			resourceId: '',
    			resourceName: ''
    		},
            detailsView: false
    	};
    }

    moreDetails = (e) => {
      this.setState({detailsView: true})
    }

    lessDetails = (e) => {
      this.setState({detailsView: false})
    }

    markAsArchive = (e, nowArchiveStatus, nowBookmarkStatus) => {
        let bookmarkStatus
        let archiveStatus
        let elementView = Object.assign({}, this.state.elementView)
        let existingRating = Object.assign({}, this.state.existingRating)
        let readStatus
        let values = {
            'mcIntResUserActivity':{
                'mcInternalResourceId' : this.props.resourceId,
                'bookmarkStatus': nowBookmarkStatus,
                'archiveStatus': nowArchiveStatus
            }
        }

        api.internalUserActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success') {
                readStatus = result.data.read_status
                existingRating = result.data.rating
                bookmarkStatus = result.data.bookmark_status
                archiveStatus = result.data.archive_status
                this.setState({readStatus: readStatus, existingRating: existingRating, bookmarkStatus: bookmarkStatus, archiveStatus: archiveStatus})
            }
        })
    }

    bookmarkResource = (e, nowBookmarkStatus) => {
        let bookmarkStatus
        let archiveStatus
        let existingRating = Object.assign({}, this.state.existingRating)
        let readStatus
        let values = {
          'mcIntResUserActivity':{
            'mcInternalResourceId' : this.props.resourceId,
            'bookmarkStatus': nowBookmarkStatus
            }
          }
        api.internalUserActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success') {
                readStatus = result.data.read_status
                existingRating = result.data.rating
                bookmarkStatus = result.data.bookmark_status
                archiveStatus = result.data.archive_status
                this.setState({readStatus: readStatus, existingRating: existingRating, bookmarkStatus: bookmarkStatus, archiveStatus: archiveStatus})
            }
        })
    }

    markAsRead = (e, nowReadStatus) => {
      let bookmarkStatus
      let archiveStatus
      let elementView = Object.assign({}, this.state.elementView)
      let existingRating = Object.assign({}, this.state.existingRating)
      let readStatus
      let values = {
          'mcIntResUserActivity':{
            'mcInternalResourceId' : this.props.resourceId,
            'readStatus': nowReadStatus
          }
      }
      api.internalUserActivity(this.props.user.accessToken, values)
      .then((result) => {
          if (result.status == 'success') {
            readStatus = result.data.read_status
            existingRating = result.data.rating
            bookmarkStatus = result.data.bookmark_status
            archiveStatus = result.data.archive_status
            this.setState({readStatus: readStatus, existingRating: existingRating, bookmarkStatus: bookmarkStatus, archiveStatus: archiveStatus})
          }
      })
    }

    changeRating = (newRating) => {
        let bookmarkStatus
        let archiveStatus
        let elementView = Object.assign({}, this.state.elementView)
        let existingRating = Object.assign({}, this.state.existingRating)
        let readStatus
        let values = {
          'mcIntResUserActivity':{
            'mcInternalResourceId' : this.props.resourceId,
            'rating' : newRating
          }
        }
        api.internalUserActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success') {
                elementView = 'already_rated'
                readStatus = result.data.read_status
                existingRating = result.data.rating
                bookmarkStatus = result.data.bookmark_status
                archiveStatus = result.data.archive_status
                this.setState({readStatus: readStatus, existingRating: existingRating, elementView: elementView, bookmarkStatus: bookmarkStatus, archiveStatus: archiveStatus})
            }
        })
    }

    componentDidMount() {
        let bookmarkStatus
        let archiveStatus
        let elementView = Object.assign({}, this.state.elementView)
        let readStatus
        let existingRating = Object.assign({}, this.state.existingRating)

        return api.userCheckPreviousInternalRating(this.props.user.accessToken, this.props.resourceId)
        .then((result) => {
            if(result.status == 'success') {
                console.log(result.data)
                if(result.data.rating == null) {
                    elementView = 'not_rated'
                    readStatus = result.data.read_status
                    bookmarkStatus = result.data.bookmark_status
                    archiveStatus = result.data.archive_status
                }
                else {
                    elementView = 'already_rated'
                    existingRating = result.data.rating
                    readStatus = result.data.read_status
                    bookmarkStatus = result.data.bookmark_status
                    archiveStatus = result.data.archive_status
                }
            }
            else if(result.status == 'error') {
                elementView = 'not_rated'
            }
            this.setState({elementView: elementView, existingRating: existingRating, readStatus: readStatus, bookmarkStatus: bookmarkStatus, archiveStatus: archiveStatus})
        })
    }

    render() {
    	let internalComponent
        let ratingComponent
        let archiveComponent
        let markAsRead = this.markAsRead
        let rateFloat = parseFloat(this.state.rating)
        let readComponent
        let bookmarkComponent
        let bookmarkResource = this.bookmarkResource
        let markAsArchive = this.markAsArchive
        let detailsButtonComponent
        let detailsComponent
        let lessDetails = this.lessDetails
        let moreDetails = this.moreDetails

        if (this.props.archiveFunction === true){
            if(this.state.archiveStatus === true) {
                let nowArchiveStatus = 0
                let nowBookmarkStatus = 0
                archiveComponent = (
                    <div>
                        <ListItemGraphic onClick= {((e) => markAsArchive(e, nowArchiveStatus, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Remove resource from Archive'}>unarchive</ListItemGraphic>
                        <ReactTooltip place="top" type="dark" effect="solid"/>
                    </div>
                )
            }
            else {
                let nowArchiveStatus = 1
                let nowBookmarkStatus = 0
                archiveComponent = (
                    <div>
                        <ListItemGraphic onClick= {((e) => markAsArchive(e, nowArchiveStatus, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Add Resource to Archive'}>archive</ListItemGraphic>
                        <ReactTooltip place="top" type="dark" effect="solid"/>
                    </div>
                )
            }
        }

        if(this.state.detailsView === true) {
            detailsButtonComponent = (
                <GridCell span="3">
                    <Button raised style={{ width: '80%' }} onClick= {((e) => lessDetails(e))}>Less Details</Button>
                </GridCell>
                )
            }
        else if (this.state.detailsView === false) {
            detailsButtonComponent = (
                <GridCell span="3">
                    <Button dense style={{ width: '80%' }} onClick= {((e) => moreDetails(e))}>More Details</Button>
                </GridCell>
                )
        }

        if(this.state.detailsView === true) {
            detailsComponent = (
                <Grid>
                    <GridCell span="3" className="grid-left-align">
                        <Typography align = "left"><i>Author: {this.props.resourceAuthor}</i></Typography>
                    </GridCell>
                    <GridCell span="9" className="grid-left-align">
                        <Typography align = "left"><i>Description: {this.props.resourceDesc}</i></Typography>
                    </GridCell>
                  </Grid>
                )
        }

        if (this.props.bookmarkFunction === true){
            if(this.state.bookmarkStatus == 1) {
                let nowBookmarkStatus = 0
                bookmarkComponent = (
                    <div>
                        <ListItemGraphic onClick= {((e) => bookmarkResource(e, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Remove Resource Bookmark'}>bookmark</ListItemGraphic>
                        <ReactTooltip place="top" type="dark" effect="solid"/>
                    </div> 
                )   
            }else {
                let nowBookmarkStatus = 1
                bookmarkComponent = (
                    <div>
                        <ListItemGraphic onClick= {((e) => bookmarkResource(e, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Bookmark Resource'}>bookmark_border</ListItemGraphic>
                        <ReactTooltip place="top" type="dark" effect="solid"/>
                    </div>
                )
            }
        }

        if (this.state.readStatus == 1){
            let nowReadStatus = 0
            readComponent = (
                <div>
                    <ListItemGraphic onClick= {((e) => markAsRead(e, nowReadStatus))} style={{cursor: 'pointer'}} data-tip={'Mark as Unread'}>drafts</ListItemGraphic>
                    <ReactTooltip place="top" type="dark" effect="solid"/>
                </div>
            )
        }
        else {
            let nowReadStatus = 1
            readComponent = (
                <div>
                    <ListItemGraphic onClick= {((e) => markAsRead(e, nowReadStatus))} style={{cursor: 'pointer'}} data-tip={'Mark as Read'}>markunread</ListItemGraphic>
                    <ReactTooltip place="top" type="dark" effect="solid"/>
                </div>
            )
        }

        if(this.state.elementView == 'not_rated') {
            ratingComponent = (
                <StarRatings
                    rating={rateFloat}
                    starDimension="25px"
                    starSpacing="4px"
                    starRatedColor="wheat"
                    changeRating={this.changeRating}
                    numberOfStars={5}
                    name='rating'
                />
            )
        }
        else if (this.state.elementView == 'done_rating') {
            ratingComponent = (
                <Typography align = "left">Thank you. Your feedback is vital!</Typography>
            )
        }
        else if (this.state.elementView == 'already_rated') {
            let rateFloat = parseFloat(this.state.existingRating)
            ratingComponent = (
                <StarRatings
                    rating={rateFloat}
                    starDimension="25px"
                    starSpacing="4px"
                    starRatedColor="wheat"
                />
            )
        }
        
    	internalComponent = (
            <div>
				<Grid>
					<GridCell span="3" className="grid-left-align">
                        <Typography align = "left">{this.props.resourceName}</Typography>
                    </GridCell>
       	            <GridCell span="2">
                        <Typography> <a href={this.props.resourceLink} target="_blank" style={{cursor: 'pointer'}}>View</a> </Typography>
                    </GridCell>
                    <GridCell span="1">
                    </GridCell>
                    <GridCell span="1">
                        {readComponent}
                    </GridCell>
                    <GridCell span="1">
                        {bookmarkComponent}
                    </GridCell>
                    <GridCell span="1">
                        {archiveComponent}
                    </GridCell>
                    <GridCell span="3">
                        {ratingComponent}
                    </GridCell>
                    <GridCell span="9" className="grid-left-align">
                        <Typography align = "left"><i>Test Track: {this.props.resourceTestTrack}</i></Typography>
                    </GridCell>
                    <GridCell span="3">
                      {detailsButtonComponent}
                    </GridCell>
                </Grid>
                {detailsComponent}
                <ListDivider />
            </div>
    	)
    	return (
            <div>
    		{internalComponent}
            </div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInternalResouceComponent);


// WEBPACK FOOTER //
// ./src/views/roadmap/UserInternalResourceComponent.jsx